import CorePageJumpLinkNavigation from './CorePageJumpLinkNavigation';

export { type CorePageJumpLinkNavigationProps } from './CorePageJumpLinkNavigation';
export default CorePageJumpLinkNavigation;
